<template>
  <div class="animated-coverart">
    <svg id="eusy2d1g0l9n1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 315 315" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
      <defs>
        <linearGradient
          id="eusy2d1g0l9n9-fill"
          x1="157.496200"
          y1="94.427700"
          x2="157.496200"
          y2="306.813500"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse">
          <stop id="eusy2d1g0l9n9-fill-0" offset="0%" stop-color="rgba(255,255,255,0)" />
          <stop id="eusy2d1g0l9n9-fill-1" offset="100%" stop-color="rgba(0,0,0,0.64)" />
        </linearGradient>
      </defs>
      <g id="eusy2d1g0l9n2">
        <circle
          id="eusy2d1g0l9n5"
          r="215.399994"
          transform="matrix(1 0 0 1 270.39999390351562 350.39999389592015)"
          fill="rgb(231,61,94)"
          stroke="none"
          stroke-width="1" />
        <circle
          id="eusy2d1g0l9n6"
          r="239.699997"
          transform="matrix(1 0 0 1 14.69999695293944 85.90000152587891)"
          fill="rgb(23,163,222)"
          stroke="none"
          stroke-width="1" />
        <circle
          id="eusy2d1g0l9n7"
          style="mix-blend-mode: multiply"
          r="215.399994"
          transform="matrix(1 0 0 1 270.39999390351562 350.39999389592015)"
          fill="rgb(231,61,94)"
          fill-opacity="0.17"
          stroke="none"
          stroke-width="1" />
        <circle
          id="eusy2d1g0l9n8"
          style="mix-blend-mode: soft-light"
          r="215.399994"
          transform="matrix(1 0 0 1 270.39999390351562 350.39999389592015)"
          opacity="0.57"
          fill="rgb(231,61,94)"
          stroke="none"
          stroke-width="1" />
        <rect
          id="eusy2d1g0l9n9"
          width="315"
          height="315"
          rx="0"
          ry="0"
          opacity="0.6000000238418579"
          fill="url(#eusy2d1g0l9n9-fill)"
          stroke="none"
          stroke-width="1" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
  .animated-coverart {
    //
  }
</style>